module.exports = __webpack_public_path__ + "img/thumbnail.870dc01f.png";